import React, { useEffect } from 'react'
import { useState } from 'react'
import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import Modal from '../../../common/modal'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../common/snippets'
import Lineinput from '../../../common/lineinput'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { ApprAuthority, crewTypeData, statusOpt } from '../constants'
import InfoIcon from '@mui/icons-material/Info'
import SuccessfullModal from "../../../common/SuccessfullModal"
import SuccessAndErrorModal from "../../../common/SuccessAndErrorModal"
import { focusElemnt, navigation1, navigation3 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import { connect } from 'react-redux'
import { addNewUserV2, getAllDriverConductor, verifyPanNumber } from '../../../../store/branchAndUserMaster/BUMAction'
import OTPModal from './OTPModal'
import { oTPForUserRoleRight } from '../../../common/jotaiState/commonStateAtoms'
import useToken from '../../../helpers/useTokens'
import { useAtom } from 'jotai'
import { modalAtom } from '../../../common/jotaiState/globalStateAtoms'
const CreateNewUser = (props) => {
    const { data, getAllDriverConductor, verifyPanNumber, updateAlertError, isEdit = false, branchData, crewNameData, rollRightData, addNewUserV2, editUserData, onLoad,loginData } = props
    const { common } = data
    const { companySettings } = { ...common }
    const CompanyWebCargoEnabledMode = companySettings?.[0]?.WebCargoEnabledMode
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [allInputs, setAllInputs] = useState({
        userName: "", emailID: "", mobileNo: "", loginId: "", password: "", rePassword: "", crewType: "", crewName: "", pan: "", IsFocApprovalAuth: "", UserMac: '', WebCargoEnabledMode :0
    })
    const [active, setActive] = useState(false)
    const [status, setStatus] = useState({ name: "Active", id: 1 })
    const [crewType, setCrewType] = useState("")
    const [crewName, setCrewName] = useState("")
    const [crewNameAllData, setCrewNameAllData] = useState("")
    const [isOpen, setIsOpen] = useState({ open: false, message: "" })
    const [verifyPan, setVerifyPan] = useState("notVerify")
    const [verifyPanError, setVerifyPanError] = useState("")
    const [selBranchName, setSelBranchName] = useState("")
    const [selRollRight, setSelRollRight] = useState("")
    const [selApprAuth, setSelApprAuth] = useState("")
    const [OTP, setOTP] = useState("")
    const [OtpModal, setOtpModal] = useState(false)
    const [, setModal] = useAtom(modalAtom)

    const [newUserError, setNewUserError] = useState({ error: false, message: "", })
    const { userName, emailID, mobileNo, loginId, password, rePassword, pan, IsFocApprovalAuth, UserMac, WebCargoEnabledMode } = allInputs
    const yesNoList = [{id:1, name:'Yes'}, {id:0, name:'No'}]
    useEffect(() => {
        focusElemnt("UMUserName")
    }, [])
    useEffect(() => {
        if (editUserData?.data !== "" && isEdit) {
            setAllInputs({
                ...allInputs, userName: editUserData?.data?.UserName, emailID: editUserData?.data?.EmailID,
                mobileNo: editUserData?.data?.ContactNo, loginId: editUserData?.data?.LoginID, password: editUserData?.data?.Password,
                rePassword: editUserData?.data?.Password, pan: editUserData?.data?.UserPanNo, IsFocApprovalAuth: yesNoList?.filter((item) => item.id === editUserData?.IsFocApprovalAuth)?.[0] || '',
                UserMac: editUserData?.data?.UserMac, WebCargoEnabledMode :CompanyWebCargoEnabledMode===1?1:editUserData?.data?.WebCargoEnabledMode
            })
            setSelBranchName(branchData?.filter((val) => val?.BranchID == editUserData?.data?.BranchID)?.[0] || "")
            setSelRollRight(rollRightData?.filter((val) => val?.RoleID === editUserData?.data?.Roleid)?.[0] || "")
            const crewType= crewTypeData?.filter((val) => val?.name?.toLowerCase() === editUserData?.data?.CrewType?.toLowerCase())?.[0] || ""
            setCrewType(crewType)
            getDriverConductorData(crewType?.id)
            setStatus(statusOpt?.filter((val) => val?.id === editUserData?.data?.IsActive)?.[0] || "")
            if (editUserData?.data?.UserPanNo !== "") {
                setVerifyPan("Verified")
            }else{
                setVerifyPan("notVerify")
            }
        }
    }, [editUserData])


    const getDriverConductorData = (isDriver) => {
        const obj = {
            intUserID: 0,
            intDriverConductorID: 0,
            intCompanyID: loginData?.intCompanyID,
            intBusID: 0,
            intIsDriver: isDriver,
            intStateID: 0,
            intCityID: 0,
            intIsActive: 1,
            CrewTypeID: isDriver,
        }
        getAllDriverConductor(obj).then((res) => {
            if (res?.status == 'Success') {
                if (res?.Data?.length > 0) {
                    setCrewNameAllData(res?.Data || [])
                    setCrewName(res?.Data?.filter((val) => val?.DriverConductorID === editUserData?.data?.CrewID)?.[0] || {DriverConductorName:"Select Crew Name"})

                } else {
                    setCrewNameAllData(res?.Data || [])
                    setCrewName({DriverConductorName:"Select Crew Name"})
                }
            } else {
                updateAlertError({ show: true, msg: res.Message })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }

    const crewTypeChange = (val) => {
        setCrewType(val)
        getDriverConductorData(val?.id)
    }

    const handleChange = (e, fieldName) => {
        const regex = new RegExp('^[0-9\""]*$');
        if (fieldName == "mobileNo") {
            if (regex.test(e.target.value)) {
                if (e.target.value.length <= (loginData?.MobileNoULimit||10)) {
                    setAllInputs({ ...allInputs, [fieldName]: e.target.value })
                }
            }
        } else {
            setAllInputs({ ...allInputs, [fieldName]: e.target.value })
        }
    }

    const handlePanNo = (e) => {
        if(pan!==""){
            const obj = {
                PanNumber: e.target.value
            }
            verifyPanNumber(obj).then((res) => {
                if (res?.status == 'True') {
                    setVerifyPan("Verified")
                } else {
                    setVerifyPanError(res.ErrMessage)
                    setVerifyPan("Invalid")
                }
            }).catch((err) => {
                console.log("Error:", err)
            })
        }
    }
    const velidation = () => {
        const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        if (userName == "") {
            updateAlertError({ show: true, msg: "Fill User Name", nextId: "UMUserName" })
            return false
        } else if (mobileNo == "") {
            updateAlertError({ show: true, msg: "Fill Mobile Number", nextId: "UMMobileNo" })
            return false
        } else if (selBranchName == "") {
            updateAlertError({ show: true, msg: "Select Branch Name", nextId: "UMBranchName" })
            return false
        } else if (loginId == "") {
            updateAlertError({ show: true, msg: "Fill Login Id", nextId: "UMLoginId" })
            return false
        } else if (password == "") {
            updateAlertError({ show: true, msg: "Fill Password", nextId: "UMPassword" })
            return false
        } else if (rePassword === "") {
            updateAlertError({ show: true, msg: "Fill RePassword", nextId: "UMRePassword" })
            return false
        } else if (password !== rePassword) {
            updateAlertError({ show: true, msg: "Password And Re-Password Do Not Match", nextId: "UMRePassword" })
            return false
        } else if (selRollRight == "") {
            updateAlertError({ show: true, msg: "Select Roll Rights", nextId: "UMUserRoleRight" })
            return false
        } else if (UserMac !== '' && UserMac?.length > 0) {
            if (!macRegex.test(UserMac)) {
                updateAlertError({ show: true, msg: 'Please Enter Valid Mac ID' })
                return false
            }
        }
        // } else if (pan == "") {
        //     updateAlertError({ show: true, msg: "Fill Pan Number", nextId: "UMPAN" })
        //     return false
        // }
        // } else if (verifyPan !== "Verified") {
        //     updateAlertError({ show: true, msg: "Enter Valid Pan Number", nextId: "UMPAN" })
        //     return false
        // }
        return true
    }
    const saveApi = (edit) => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            UserID: edit ? editUserData?.id : 0,
            BranchID: selBranchName?.BranchID || 0,
            Username: userName,
            EmailId: emailID,
            ContactNo: mobileNo,
            LoginID: loginId,
            Password: password,
            IsActive: status?.id || 0,
            RoleID: selRollRight?.RoleID,
            CrewType: crewType?.id || 0,
            CrewID: crewName?.DriverConductorID || 0,
            PanNo: pan,
            IsFocApprovalAuth: IsFocApprovalAuth?.id||0,
            WebCargoEnabledMode: WebCargoEnabledMode||0,
            UserMac :UserMac||''
        }
        // addNewUserV2()
        addNewUserV2(obj).then((res) => {
            if (res?.status == 'Success') {
                setOtpModal(false)
                setIsOpen({ ...isOpen, open: true, message: edit ? "User Detail Updates\nSaved Successfully!" : "New User Details\nSaved Successfully!" })
            } else {
                // updateAlertError({ show: true, msg: res.Message })
                setNewUserError({ ...newUserError, error: true, message: res.Message })
            }
        }).catch((err) => {
            console.log("Error:", err)
        })
    }
    const sendOTPRequest=()=>{
        const obj={
            strOTPType:"UR",
            intCompanyId:loginData?.intCompanyID,
            intRoleID: selRollRight?.RoleID,
            intSaveType:2,
            intOTPSendType:selApprAuth?.id
        }
        oTPForUserRoleRight(obj).then((res) => {
            if (res?.Status == true) {
                setOTP(res.OTP)
                setOtpModal(true)
            } else {
                setOTP("")
                updateAlertError({ show: true, msg: res.ErrMessage })
            }
        }).catch((err) => {
            updateAlertError({ show: true, msg: err })
            console.log("Error:", err)
        })
    }
    const onSave = () => {
        if (velidation()) {
            if (isEdit) {
                if(rollRightData?.[0]?.IsOtpOnUserRights===1){
                    if (selApprAuth === "") {
                        updateAlertError({ show: true, msg: "Select Approval Authority", nextId: "UmAppAuth" })
                    } else {
                        sendOTPRequest()
                    }
                }else{
                    saveApi(true)  
                }
            } else {
                saveApi(false)
                // setIsOpen({...isOpen,open:true,message:"New User Details\nSaved Successfully!"})
            }
        }
    }
    const requiredLabelTxt = (label) => (
        <span>
            {label}
            <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
        </span>
    )
    const validateMacAddress = (address) => {
        // Regular expression to validate MAC address
        const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        if (address!=='' && !macRegex.test(address)) {
            updateAlertError({ show: true, msg: 'Please Enter Valid Mac ID' })
            setAllInputs((prev) => ({ ...prev, UserMac: '' }))
        }
    };
    return (
        <>
            <Modal headTxt={isEdit ? "Edit User" : `Create New User`} modalStyle={modalStyle} modalClass={'booking-popup'} width={'69%'} closeId={"closeButton"} updateModal={setModal} sx={{ marginTop: '20px' }}>
                <Stack style={{ margin: "8px 10px" }}>
                    <Grid container >
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'} >
                                <Lineinput
                                    icon={"reset"}
                                    id={"UMUserName"}
                                    // label={'User Name'}
                                    label={requiredLabelTxt('User Name')}
                                    value={userName}
                                    type="text"
                                    name="User Name"
                                    sx={{ margin: '8px', width: '100%' }}
                                    star={true}
                                    onChange={(e) => handleChange(e, "userName")}
                                    onKeyDown={(e) => navigation1(e, "UMUserEmailId", "UMSave")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"reset"}
                                    id={"UMUserEmailId"}
                                    // id={"consignmentType"}
                                    label={'User Email ID'}
                                    value={emailID}
                                    type="text"
                                    name="User Email ID"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "emailID")}
                                    onKeyDown={(e) => navigation1(e, "UMMobileNo", "UMUserName")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"reset"}
                                    id={"UMMobileNo"}
                                    // label={'Mobile No'}
                                    label={requiredLabelTxt('Mobile No')}
                                    value={mobileNo}
                                    type="text"
                                    name="Mobile No"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "mobileNo")}
                                    onKeyDown={(e) => navigation1(e, "UMBranchName", "UMUserEmailId")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item>
                                <DropDownOA
                                    id={"UMBranchName"}
                                    data={branchData || []}
                                    defaultvalue={selBranchName?.BranchName || ''}
                                    width="100%"
                                    searchPlaceholder={`Search Branch Name`}
                                    label={"Branch Name"}
                                    field={'compulsory'}
                                    dataKey={`BranchName`}
                                    idKey={`BranchID`}
                                    nextId={"UMLoginId"}
                                    prevId={"UMMobileNo"}
                                    onSelect={(value) => setSelBranchName(value)}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Stack>
                <Stack style={{ margin: "8px 10px" }}>
                    <Grid container >
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"reset"}
                                    id={"UMLoginId"}
                                    // label={'Login ID'}
                                    label={requiredLabelTxt('Login ID')}
                                    value={loginId}
                                    type="text"
                                    name="Login ID"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "loginId")}
                                    onKeyDown={(e) => navigation1(e, "UMPassword", "UMBranchName")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"pwd"}
                                    id={"UMPassword"}
                                    // label={'Password'}
                                    label={requiredLabelTxt('Password')}
                                    value={password}
                                    type="password"
                                    name="Password"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "password")}
                                    onKeyDown={(e) => navigation1(e, "UMRePassword", "UMLoginId")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"pwd"}
                                    id={"UMRePassword"}
                                    // label={'Re-Password'}
                                    label={requiredLabelTxt('Re-Password')}
                                    value={rePassword}
                                    type="password"
                                    name="Re-Password"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "rePassword")}
                                    onKeyDown={(e) => navigation1(e, "UMUserRoleRight", "UMPassword")}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item>
                                <DropDownOA
                                    id={"UMUserRoleRight"}
                                    data={rollRightData || []}
                                    defaultvalue={selRollRight?.RoleName || ''}
                                    width="100%"
                                    searchPlaceholder={`Search User Roll Rights`}
                                    label={"User Roll Rights"}
                                    field={'compulsory'}
                                    dataKey={`RoleName`}
                                    idKey={`RoleID`}
                                    nextId={"UMCrewType"}
                                    prevId={"UMRePassword"}
                                    onSelect={(value) => setSelRollRight(value)}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Stack>
                <Stack style={{ margin: "8px 10px" }}>
                    <Grid container style={{display:'flex',flexWrap:'nowrap'}} >
                        <Grid item xs={6} md={3}>
                            <Item>
                                <DropDownOA
                                    id={"UMCrewType"}
                                    data={crewTypeData || []}
                                    defaultvalue={crewType?.name || ''}
                                    width="100%"
                                    searchPlaceholder={`Search Crew Type`}
                                    label={"Crew Type"}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    nextId={"UMCrewName"}
                                    prevId={"UMUserRoleRight"}
                                    onSelect={(value) => crewTypeChange(value)}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Item>
                                <DropDownOA
                                    id={"UMCrewName"}
                                    data={crewNameAllData || []}
                                    defaultvalue={crewName?.DriverConductorName || ''}
                                    value={crewName?.DriverConductorName || ''}
                                    width="100%"
                                    searchPlaceholder={`Search Crew Name`}
                                    label={"Crew Name"}
                                    dataKey={`DriverConductorName`}
                                    idKey={`DriverConductorID`}
                                    nextId={"UMPAN"}
                                    prevId={"UMCrewType"}
                                    onSelect={(value) => setCrewName(value)}
                                />
                            </Item>
                        </Grid>
                        <Grid item xs={6} md={verifyPan == "Verified"?2.1:3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    icon={"reset"}
                                    id={"UMPAN"}
                                    // label={requiredLabelTxt('PAN')}
                                    label={"PAN"}
                                    value={pan}
                                    type="text"
                                    name="PAN"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onBlur={(e) => handlePanNo(e)}
                                    onChange={(e) => handleChange(e, "pan")}
                                    onKeyDown={(e) => navigation1(e,'IsFocAuthority', "UMCrewName")}
                                />
                            </Item>
                        </Grid>
                        {
                            verifyPan == "Verified" ?
                                <Grid item xs={6} md={0.9}>

                                    <Box sx={{ marginTop: "14px", marginLeft: "5px", height: "30px", display: "flex", alignItems: "center", gap: "5px", color: "#14C508" }}>
                                        <VerifiedUserIcon />
                                        <span>Verified</span>
                                    </Box>
                                </Grid> : ""
                        }
                        <Grid item xs={6} md={3}>
                            <Item>
                                <DropDownOA
                                    id={"IsFocAuthority"}
                                    data={yesNoList || []}
                                    defaultvalue={IsFocApprovalAuth?.name || ''}
                                    width="100%"
                                    searchPlaceholder={`Search Crew Name`}
                                    label={"FOC Authority?"}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    nextId={'UserMac'}
                                    prevId={"UMPAN"}
                                    onSelect={(value) => {setAllInputs((prev)=>({...prev, IsFocApprovalAuth:value }))}}
                                />
                            </Item>
                        </Grid>
                    </Grid>
                </Stack>
                <Stack style={{ margin: "8px 10px" }}>
                    <Grid container style={{ display: 'flex', flexWrap: 'nowrap' }} >
                        <Grid item xs={6} md={3}>
                            <Item className={'input--wrapper'}>
                                <Lineinput
                                    // icon={"reset"}
                                    id={"UserMac"}
                                    label={requiredLabelTxt('Mac ID')}
                                    value={UserMac}
                                    type="text"
                                    name="UserMac"
                                    sx={{ margin: '8px', width: '100%' }}
                                    onChange={(e) => handleChange(e, "UserMac")}
                                    onBlur={(e)=>{validateMacAddress(e.target.value)}}
                                    onKeyDown={(e) => navigation1(e, "enableCargo", "IsFocAuthority")}
                                />
                            </Item>
                        </Grid>
                        <Grid item md={6}>
                        <Item className={'input--wrapper'}>
                            <FormControlLabel
                                value="end"
                                control={<Checkbox checked={WebCargoEnabledMode  === 1} id='enableCargo' disabled={CompanyWebCargoEnabledMode===1} />}
                                onKeyDown={(e) => {
                                    navigation3(e, isEdit ? "UmAppAuth" : "UMUserStatus", 'UserMac', () => { })
                                }}
                                label={
                                    <Typography variant='h6' sx={{ fontWeight: '500', color: '#444 !important' }}>
                                       {`Mac authentication ${WebCargoEnabledMode  === 1?'Not':''} Required for the User`}
                                    </Typography>
                                }
                                onChange={(event) => {
                                    setAllInputs((prev)=>({
                                        ...prev,WebCargoEnabledMode:event.target.checked ? 1 : 0
                                    }))
                                }}
                                labelPlacement="end"
                            />
                            </Item>
                        </Grid>
                    </Grid>
                </Stack>
                <Divider />
                <Box className='reportButton' sx={{ display: 'flex', justifyContent: 'end', padding: "12px 14px", gap: "12px" }}>
                    {isEdit && rollRightData?.[0]?.IsOtpOnUserRights==1 ?
                        <>
                            <Item sx={sx.itemsx} style={{ width: "295px" }} className={'input--wrapper'}>
                                <DropDownOA
                                    id={"UmAppAuth"}
                                    data={ApprAuthority || []}
                                    defaultvalue={selApprAuth?.name || ''}
                                    width="100%"
                                    searchPlaceholder={`Search Branch Name`}
                                    label={"Approval Authority"}
                                    dataKey={`name`}
                                    idKey={`id`}
                                    nextId={"UMUserStatus"}
                                    prevId={"UMPAN"}
                                    onSelect={(value) => setSelApprAuth(value)}
                                />
                            </Item>

                            <Item sx={sx.itemsx} >
                                <Box style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: "500", fontSize: "13px" }}>
                                    <InfoIcon style={{ color: "#0086FF" }} />
                                    <span style={{ color: "#1E59A7" }}>OTP will send to the Management as per Selection</span>
                                </Box>
                            </Item>
                        </> : ""
                    }

                    <Box style={{ width: "150px" }} >
                        <DropDownOA
                            id={"UMUserStatus"}
                            defaultvalue={status?.name || ""}
                            data={statusOpt || []}
                            width="100%"
                            searchPlaceholder={`Search User Status`}
                            label={"User Status"}
                            dataKey={`name`}
                            idKey={`id`}
                            nextId={"UMCancel"}
                            prevId={"UMPAN"}
                            isError={status?.id == 0}
                            isSuccess={status?.id == 1}
                            onSelect={(value) => setStatus(value)}
                        />
                    </Box>
                    <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMSave", "UMUserStatus", () => { })}>
                        <Button id={"UMCancel"} variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => setModal()}>
                            CANCEL
                        </Button>
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "UMUserName", "UMCancel", () => { })}>
                        <Button variant="contained" id="UMSave" style={{ ...sx.fullHeight, ...sx.novp, padding: "5px 20px" }} className="btn btn-primary"
                            onClick={() => onSave()}
                        >
                            Save
                        </Button>
                    </Item>
                </Box>
            {OtpModal?<OTPModal saveApi={saveApi} OTP={OTP} isOpen={isOpen} setIsOpen={setIsOpen} sendOTPRequest={sendOTPRequest} updateModal={setModal}/>:""}
            </Modal>
            <SuccessfullModal modalStyle={modalStyle} handleClose={() => { setIsOpen({ ...isOpen, open: false, message: "" }); onLoad(); setModal();focusElemnt("UMStatus")}} open={isOpen?.open} title={isOpen?.message} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setVerifyPan("notVerify")} isError={true} open={verifyPan === "Invalid"} title={verifyPanError || ""} />
            <SuccessAndErrorModal modalStyle={modalStyle} handleClose={() => setNewUserError({ ...newUserError, error: false })} isError={true} open={newUserError.error} title={newUserError?.message} />
        </>
    )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
     getAllDriverConductor, updateAlertError, verifyPanNumber, updateAlertError, addNewUserV2
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewUser)